var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yj-steps",class:[
       !_vm.simple && 'yj-steps--' + _vm.direction,
       _vm.simple && 'yj-steps--simple'
     ]},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/steps/src/steps.vue